import React from "react";

import { IonButton, IonCard } from "@ionic/react";
import { ImageType, ProductImageTypes, Product as TProduct } from "@core/types";
import classNames from "classnames/bind";
import styles from "./ProductsSlider.module.scss";
import { CustomSlider } from "../CustomSlider/CustomSlider";
import { useConfig } from "../../providers/config";
import { Image } from "../Image/Image";

type SliderExtraButton = {
  extraButtonTitle?: string;
  isHaveExtraButton?: boolean;
  extraButtonHandler?: () => void;
};

interface ProductsSliderProps extends SliderExtraButton {
  renderItem: (item: TProduct) => React.ReactNode;
  isHavePagination?: boolean;
  haveImage?: boolean;
  items: TProduct[];
  firstImage?: ImageType;
  containerClassName?: string;
  onImageClick?: () => void;
}

const cx = classNames.bind(styles);

const ProductsSlider = ({
  items,
  isHaveExtraButton,
  extraButtonTitle = "All",
  extraButtonHandler,
  isHavePagination = false,
  renderItem,
  haveImage,
  firstImage,
  containerClassName,
  onImageClick,
}: ProductsSliderProps) => {
  const config = useConfig();

  return (
    <CustomSlider containerClassName={containerClassName}>
      {haveImage && (
        <Image
          lazyLoad={false}
          image={firstImage}
          placeholder={firstImage?.base64}
          className="w-28 h-[11.5rem] rounded-2xl"
          onClick={() => onImageClick?.()}
        />
      )}
      {items?.map((item) => {
        return (
          <div
            key={item.id}
            className={cx("slider__item", config?.cardProduct ? "ion-slide-max-width" : "parhato-ion-slide-max-width")}
          >
            {renderItem(item)}
          </div>
        );
      })}
      {isHaveExtraButton && (
        <div
          className={cx(
            "ion-hide-md-up",
            "see-all-slide",
            config?.cardProduct ? "ion-slide-max-width" : "parhato-ion-slide-max-width",
          )}
        >
          <div className={cx("skeletonWidth", "see-all-wrapper")}>
            <IonCard className={cx("shadow")}>
              <IonButton className={cx("see-all")} onClick={extraButtonHandler}>
                {extraButtonTitle}
              </IonButton>
            </IonCard>
          </div>
        </div>
      )}
    </CustomSlider>
  );
};

export { ProductsSlider };
